import { render, staticRenderFns } from "./clinicPlanDrugList.vue?vue&type=template&id=05be042b&scoped=true"
import script from "./clinicPlanDrugList.vue?vue&type=script&lang=js"
export * from "./clinicPlanDrugList.vue?vue&type=script&lang=js"
import style0 from "./clinicPlanDrugList.vue?vue&type=style&index=0&id=05be042b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05be042b",
  null
  
)

export default component.exports